var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTutorialIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".TutorialIcon-1 { opacity:.5; }\n      .TutorialIcon-2 { fill:#fff; }\n      .TutorialIcon-2,.TutorialIcon-3 { stroke-width:0px; }\n      .TutorialIcon-3 { fill: currentColor; }"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "TutorialIcon-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "TutorialIcon-3",
  d: "m12.34,20.89c-2.26,0-4.51-.86-6.23-2.58-1.67-1.67-2.58-3.88-2.58-6.23s.92-4.57,2.58-6.23c1.66-1.67,3.88-2.58,6.23-2.58s4.57.92,6.23,2.58c1.67,1.67,2.58,3.88,2.58,6.23s-.92,4.57-2.58,6.23h0c-1.72,1.72-3.98,2.58-6.23,2.58Zm0-16.63c-2.09,0-4.05.81-5.53,2.29-1.48,1.48-2.29,3.44-2.29,5.53s.81,4.05,2.29,5.53c3.05,3.05,8.01,3.05,11.05,0h0c1.48-1.48,2.29-3.44,2.29-5.53s-.81-4.05-2.29-5.53c-1.48-1.48-3.44-2.29-5.53-2.29Z"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "TutorialIcon-2",
  x: 9.62,
  y: 9.36,
  width: 5.43,
  height: 5.43,
  transform: "translate(-4.93 12.26) rotate(-45)"
})));
export default SvgTutorialIcon;